export default __webpack_public_path__ + "static/media/med2lab_logo.56fd2aea.png";